import { useLayout } from "../../contexts/LayoutContext";
import { useEffect } from "react";
import Banner from '../../components/ui/Banner';
import About from './components/HomeAboutPreview';
import HomeHighlightPrograms from './components/HomeHighlightPrograms';
import HomeSuccessHighlightPreview from './components/HomeSuccessHighlightPreview';
import Schedule from './components/HomeSchedulePreview';
import HomeTestimonialPreview from './components/HomeTestimonialPreview';
import HomeBlogPreview from './components/HomeBlogPreview';
import CallToAction from '../../components/ui/CallToAction';
import SeoMeta from '../../components/ui/SeoMeta';
import FadeInOnScroll from '../../components/ui/FadeInOnScroll';

export default function HomePage() {
  const { setIsFullWidth } = useLayout();
  useEffect(() => {
    setIsFullWidth(true);
    return () => setIsFullWidth(false);
  }, [setIsFullWidth]);

  return (
    <>
      <SeoMeta page="home" />
      {/* Banner thường đặt static, không scroll nên khỏi cần */}
      <Banner />
      <FadeInOnScroll>
        <About />
      </FadeInOnScroll>
      <FadeInOnScroll delay={0.1}>
        <HomeHighlightPrograms />
      </FadeInOnScroll>
      <FadeInOnScroll delay={0.2}>
        <HomeSuccessHighlightPreview />
      </FadeInOnScroll>
      <FadeInOnScroll delay={0.3}>
        <Schedule />
      </FadeInOnScroll>
      <FadeInOnScroll delay={0.4}>
        <HomeTestimonialPreview />
      </FadeInOnScroll>
      <FadeInOnScroll delay={0.5}>
        <HomeBlogPreview />
      </FadeInOnScroll>
      <FadeInOnScroll delay={0.6}>
        <CallToAction />
      </FadeInOnScroll>
    </>
  );
}
